import api from '@/lib/axios';

export interface StoreInfo {
  _id: string;
  name: string;
  storeNumber: string;
  storeAddress?: string;
}

export interface SwitchStoreResponse {
  message: string;
  token: string;
  refreshToken: string;
  user: {
    _id: string;
    name: string;
    email: string;
    position: string;
    role: 'user' | 'admin';
    store: StoreInfo;
    authorizedStores?: StoreInfo[];
    status: string;
    departments: string[];
  };
}

interface AccessibleStoresResponse {
  stores: StoreInfo[];
  currentStoreId: string;
  hasMultiStoreAccess: boolean;
}

const userStoreService = {
  /**
   * Get all stores the current user can access
   */
  getAccessibleStores: async (): Promise<AccessibleStoresResponse> => {
    const response = await api.get('/api/user-store/accessible');
    return response.data;
  },

  /**
   * Switch the current user's store
   * Available for users with multi-store access
   */
  switchStore: async (storeId: string): Promise<SwitchStoreResponse> => {
    const response = await api.post('/api/user-store/switch', { storeId });
    return response.data;
  }
};

export default userStoreService;
